'use es6';

import { createContext as createContext$1, useContext } from 'react'; // src/index.ts

function getErrorMessage(hook, provider) {
  return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}

function createContext(options = {}) {
  const {
    name,
    strict = true,
    hookName = "useContext",
    providerName = "Provider",
    errorMessage,
    defaultValue
  } = options;
  const Context = /*#__PURE__*/createContext$1(defaultValue);
  Context.displayName = name;

  function useContext$1() {
    var _a;

    const context = useContext(Context);

    if (!context && strict) {
      const error = new Error(errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName));
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext$1);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext$1, Context];
}

export { createContext };